import React, { useCallback } from 'react';
import {
  StackModalAction,
  StackModalActionType,
  StackModalState,
} from '../../types';
import { validateStackForm } from '../../utils/validateStackForm';

export const useFormActions = (
  state: StackModalState,
  dispatch: React.Dispatch<StackModalAction>,
) => {
  const setStackName = useCallback(
    (name: string) => {
      dispatch({ type: StackModalActionType.SET_STACK_NAME, payload: name });
    },
    [dispatch],
  );

  const handleNameChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch({
        type: StackModalActionType.SET_STACK_NAME,
        payload: event.target.value,
      });
    },
    [dispatch],
  );

  const showAlert = useCallback(
    (message: string) => {
      dispatch({ type: StackModalActionType.SHOW_ALERT, payload: message });
    },
    [dispatch],
  );

  const clearAlert = useCallback(() => {
    dispatch({ type: StackModalActionType.CLEAR_ALERT });
  }, [dispatch]);

  const setValidationErrors = useCallback(
    (errors: Record<string, string>) => {
      dispatch({
        type: StackModalActionType.SET_VALIDATION_ERRORS,
        payload: errors,
      });
    },
    [dispatch],
  );

  const clearValidationError = useCallback(
    (key: string) => {
      dispatch({
        type: StackModalActionType.CLEAR_VALIDATION_ERROR,
        payload: key,
      });
    },
    [dispatch],
  );

  const clearControlModeValidationError = useCallback(
    (index: number, field?: string) => {
      dispatch({
        type: StackModalActionType.CLEAR_CONTROL_MODE_VALIDATION_ERROR,
        payload: { index, field },
      });
    },
    [dispatch],
  );

  const validateForm = useCallback(() => {
    const { isValid, errors, nameError } = validateStackForm(
      state.stackName,
      state.controlModes,
    );

    if (nameError) {
      dispatch({
        type: StackModalActionType.SET_NAME_ERROR,
        payload: nameError,
      });
    }

    dispatch({
      type: StackModalActionType.SET_VALIDATION_ERRORS,
      payload: errors,
    });

    return isValid;
  }, [state.stackName, state.controlModes, dispatch]);

  return {
    setStackName,
    handleNameChange,
    showAlert,
    clearAlert,
    setValidationErrors,
    clearValidationError,
    clearControlModeValidationError,
    validateForm,
  };
};
